import type { ICartSummary } from "@/types";
import { useCartItems } from "@/components/cart/hooks/useCartItems";
import { useMemo } from "react";

export const useCartSummary = (menuId: number | null): ICartSummary => {
  const items = useCartItems(menuId);

  return useMemo(() => {
    const dishCount = items.length;
    const totalQuantity = items.reduce(
      (sum, item) => sum + (item.quantity ?? 0),
      0
    );

    return { dishCount, totalQuantity, hasItems: dishCount > 0 };
  }, [items]);
};
